// extracted by mini-css-extract-plugin
module.exports = {"image":"Picture-module-image"};